import { render, staticRenderFns } from "./ScorePopup.vue?vue&type=template&id=7fef0b2c&scoped=true&"
import script from "./ScorePopup.vue?vue&type=script&lang=js&"
export * from "./ScorePopup.vue?vue&type=script&lang=js&"
import style0 from "./ScorePopup.vue?vue&type=style&index=0&id=7fef0b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef0b2c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardTitle,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fef0b2c')) {
      api.createRecord('7fef0b2c', component.options)
    } else {
      api.reload('7fef0b2c', component.options)
    }
    module.hot.accept("./ScorePopup.vue?vue&type=template&id=7fef0b2c&scoped=true&", function () {
      api.rerender('7fef0b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScorePopup.vue"
export default component.exports